import { EmptyStateIllustration } from './EmptyStateIllustration';
import './EmptyState.scss';

export type EmptyStateTheme = 'light' | 'dark';

interface EmptyStateProps {
    /** A message to display with the empty state image */
    message?: string;
    /**
     * The size of the empty state image.
     * Small has text to the side
     * Large has text underneath
     * @default 'large'
     */
    size?: 'small' | 'large';
    /**
     * light or dark mode
     * @default 'light'
     *  */
    theme?: EmptyStateTheme;
}

export function EmptyState({ message, size = 'large', theme = 'light' }: EmptyStateProps) {
    return (
        <div className="EmptyState" data-size={size} data-testid="EmptyState">
            <div className="EmptyState__image">
                <EmptyStateIllustration theme={theme} />
            </div>
            {message != null && <p className="EmptyState__message">{message}</p>}
        </div>
    );
}
